var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.72 23.52C19.2272 23.52 24.48 18.2672 24.48 11.76C24.48 5.2528 19.2272 0 12.72 0C6.21276 0 0.959961 5.2528 0.959961 11.76C0.959961 18.2672 6.21276 23.52 12.72 23.52ZM12.72 3.9984C13.4256 3.9984 14.0005 4.57333 14.0005 5.27893C14.0005 5.98453 13.4256 6.53333 12.72 6.53333C12.0144 6.53333 11.4394 5.9584 11.4394 5.2528C11.4394 4.5472 12.0144 3.9984 12.72 3.9984ZM9.53169 9.85227C9.97596 9.2512 10.5509 8.75467 11.1781 8.33653C12.3802 7.57867 13.9744 7.9184 13.9744 9.3296V16.3072C13.9744 17.3525 14.6538 17.4832 15.464 17.1173C15.6469 17.0389 15.8298 17.1173 15.9082 17.2741C15.9605 17.3787 15.9344 17.5093 15.8821 17.6139C15.4378 18.2149 14.8629 18.7115 14.2357 19.1296C13.0336 19.8875 11.4394 19.5477 11.4394 18.1365V11.1851C11.4394 10.1397 10.76 10.0091 9.94983 10.3749C9.7669 10.4533 9.58396 10.3749 9.50556 10.2181C9.45329 10.0875 9.47943 9.9568 9.53169 9.85227Z",
    fill: "#CEB96F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoI);
export default __webpack_public_path__ + "static/media/info-i.aee8fdac24d7af10301fbf99aa222d42.svg";
export { ForwardRef as ReactComponent };